export const lstorageType = {
    hoUseAuth: 'housau',
    daLastAccess: 'dalaac',
    vwFile: 'vwfile'    
}